import React from 'react';
import {Button, Col, Divider, Form, Row, Typography} from 'antd';
import * as Yup from 'yup';
import {Formik} from "formik";
import {
  DateTimeInput,
  TextAreaInput,
  TextInput
} from "../../Boilerplate/formikComponents";
import {cloneDeep} from "lodash";
import moment from "moment";
import * as R from 'ramda';

export const MeetingMinuteForm = props => {
  const { meetingMinutes, projectid, onCancel, onSubmit, userid } = props;
  let initials, edit = false;
  if (meetingMinutes) {
    initials = cloneDeep(meetingMinutes);
    edit = true;
  } else {
    initials = {
      meetingdatetime: moment().startOf('day').add(14, 'hours'),
    };
  }
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    }
  };
  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 16,
        offset: 8,
      },
    },
  };
  return (
    <Formik
      initialValues = {initials}
      onSubmit={(values, { setSubmitting }) => {
        values = cloneDeep(values);
        onSubmit && onSubmit(values);
      }}
      validationSchema={Yup.object().shape({
        id: Yup.string().nullable(),
        number: Yup.string(),
      })}
    >
      {props => {
        const {
          values, touched, errors, isSubmitting, handleChange, handleBlur, dirty,
          handleSubmit,
          handleReset,
        } = props;
        return (
          <Form>
            <TextInput {...props} formItemLayout={formItemLayout} label='Meeting #' name='number' placeholder='Enter a number'/>
            {!edit && <Row style={{ marginTop: -24, fontSize: 13 }}>
              <Col xs={24} sm={0} style={{ width: 400 }}>
                <Typography><Typography.Paragraph><Typography.Text type={'secondary'}>
                  cProject will auto generate this if left blank. The Meeting # is intended to be used as a communication
                  reference, written or verbal. [Example: "John, was there new business for Meeting
                  #22?"]</Typography.Text></Typography.Paragraph></Typography>
              </Col>
              <Col xs={0} sm={16} offset={8} style={{ width: 400 }}>
                <Typography><Typography.Paragraph><Typography.Text type={'secondary'}>cProject will auto generate this
                  if left blank. The Meeting # is intended to be used as a communication reference, written or verbal.
                  [Example: "John, was there new business for Meeting
                  #22?"]</Typography.Text></Typography.Paragraph></Typography>
              </Col>
            </Row>}
            <DateTimeInput {...props} pickerLayout={{ dropdownClassName: 'highlight-time-picker' }} formItemLayout={formItemLayout} label='Meeting Time' name='meetingdatetime'/>
            <TextInput {...props} formItemLayout={formItemLayout} label='Meeting Type' name='type' placeholder='Meeting Type...'/>
            <Divider/>
            <TextAreaInput {...props} formItemLayout={formItemLayout} label='Attendees' name='attendees' placeholder='Attendees...'/>
            <Divider>Meeting Notes</Divider>
            <TextAreaInput {...props} formItemLayout={formItemLayout} label='Safety' name='safety' placeholder='Safety Issues...'/>
            <TextAreaInput {...props} formItemLayout={formItemLayout} label='Meeting Notes' name='notes' placeholder='Meeting Notes...'/>
            <TextAreaInput {...props} formItemLayout={formItemLayout} label='RFIs' name='rfis' placeholder='RFIs...'/>
            <TextAreaInput {...props} formItemLayout={formItemLayout} label='New Business' name='newbusiness' placeholder='New Business...'/>
            <Divider>Additional Information</Divider>
            <DateTimeInput {...props} pickerLayout={{ dropdownClassName: 'highlight-time-picker' }} formItemLayout={formItemLayout} label='Next Meeting Time' name='nextmeetingdatetime'/>

            <Form.Item className='submit-controls' {...tailFormItemLayout}>
              <Button.Group compact>
                <Button onClick={handleSubmit} type='primary'>Save</Button>
                <Button onClick={handleReset}>Clear</Button>
                <Button onClick={onCancel}>Cancel</Button>
              </Button.Group>
            </Form.Item>
          </Form>
        );
      }}
    </Formik>
  );
};


// WEBPACK FOOTER //
// ./src/components/Projects/MeetingMinutes/MeetingMinuteForm.js